import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../PreLoader.css";

const VEA_GROUP = ["V", "E", "A", "G", "r", "o", "u", "p"];

// Optionally accept a prop for dynamic loading time
interface PreLoaderProps {
  loadingTime?: number; // in ms
  isLoading?: boolean; // for external control
}

const DEFAULT_DURATION = 1800; // fallback duration

const PreLoader: React.FC<PreLoaderProps> = ({
  loadingTime,
  isLoading: externalLoading,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  // Detect dark mode
  const isDark =
    document.documentElement.classList.contains("dark") ||
    window.matchMedia("(prefers-color-scheme: dark)")
      .matches;

  useEffect(() => {
    // Check if we're navigating between blog pages
    const isBlogNavigation =
      (prevPath.current.startsWith("/blog/") &&
        location.pathname === "/blog") ||
      (prevPath.current === "/blog" &&
        location.pathname.startsWith("/blog/")) ||
      (prevPath.current.startsWith("/blog/") &&
        location.pathname.startsWith("/blog/"));

    const isCaseNavigation =
      (prevPath.current.startsWith("/cases/") &&
        location.pathname === "/cases") ||
      (prevPath.current === "/cases" &&
        location.pathname.startsWith("/cases/")) ||
      (prevPath.current.startsWith("/cases/") &&
        location.pathname.startsWith("/cases/"));

    // On first mount, it's initial load
    if (isInitialLoad) {
      setIsLoading(true);
      const timer = setTimeout(() => {
        setIsLoading(false);
        setIsInitialLoad(false);
        prevPath.current = location.pathname;
      }, loadingTime || DEFAULT_DURATION);
      return () => clearTimeout(timer);
    } else if (prevPath.current !== location.pathname) {
      // Skip loading for blog navigation
      if (isBlogNavigation || isCaseNavigation) {
        setIsLoading(false);
        prevPath.current = location.pathname;
        return;
      }

      // On route change
      setIsLoading(true);
      const timer = setTimeout(() => {
        setIsLoading(false);
        prevPath.current = location.pathname;
      }, loadingTime || DEFAULT_DURATION);
      return () => clearTimeout(timer);
    } else if (externalLoading !== undefined) {
      setIsLoading(externalLoading);
    }
    // eslint-disable-next-line
  }, [location.pathname, loadingTime, externalLoading]);

  if (!isLoading) return null;

  // Choose background class
  let bgClass = "";
  if (isInitialLoad) {
    bgClass = isDark ? "solid-dark" : "solid-light";
  } else {
    bgClass = isDark ? "blur-dark" : "blur-light";
  }

  return (
    <div className={`preloader-bg ${bgClass}`}>
      <div className="loading-container">
        <div className="loading-text">
          {VEA_GROUP.map((char, idx) => (
            <span key={idx}>{char}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreLoader;
